<div class="export-trends-card analytics-card-host" [class.is-refreshing]="isLoading()">
  <div class="card-header">
    <div class="header-text">
      <h3 class="card-title">PureOriginal Export Trends</h3>
      <span class="card-subtitle">Export volume over time</span>
    </div>
    <div class="header-right">
      <div class="legend">
        <div class="legend-item">
          <span class="legend-dot purple"></span>
          <span class="legend-label">Main DB</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot amber"></span>
          <span class="legend-label">WinOLS5</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot green"></span>
          <span class="legend-label">Reseller</span>
        </div>
      </div>
      <div class="granularity-toggle">
        <button [class.active]="granularity() === 'DAY'" (click)="onGranularityChange('DAY')">Day</button>
        <button [class.active]="granularity() === 'WEEK'" (click)="onGranularityChange('WEEK')">Week</button>
        <button [class.active]="granularity() === 'MONTH'" (click)="onGranularityChange('MONTH')">Month</button>
      </div>
    </div>
  </div>

  <div class="chart-container" *ngIf="chartData.length > 0">
    <ngx-charts-line-chart
      [results]="chartData"
      [scheme]="colorScheme"
      [xAxis]="true"
      [yAxis]="true"
      [showGridLines]="true"
      [autoScale]="true"
      [animations]="true"
      [xAxisTickFormatting]="formatXAxisTick">
    </ngx-charts-line-chart>
  </div>
  <div class="chart-empty" *ngIf="!isLoading() && chartData.length === 0">
    <span class="empty-text">No export trend data available</span>
  </div>
</div>
